export const MY_BALANCE = 'my-balance';
